import IntegrationToken from '@apps/finance/admin/tokens/integration'
import Details from '@admin/components/details'
import PropTypes from 'prop-types'
import React from 'react'

const Overview = ({ revenue_type, integration }) => {

  const details = {
    audits: `finance_revenue_types/${revenue_type.id}`,
    comments: `finance_revenue_types/${revenue_type.id}`,
    sections: [
      {
        title: 't(Revenue Type Details)',
        items: [
          { label: 't(Title)', content: revenue_type.title },
          { label: 't(Description)', content: revenue_type.description }
        ]
      }
    ]
  }

  if(integration) {
    details.sections.push({
      title: <IntegrationToken integration={ integration } />,
      padded: false,
      items: [
        { label: 'Expense Code', content: revenue_type.integration.expense_code },
        { label: 'Source Code', content: revenue_type.integration.source_code }
      ]
    })
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  revenue_type: PropTypes.object,
  integration: PropTypes.object
}

export default Overview
